export default __webpack_public_path__ + "static/mizu-light-47172d12b39e1db443bffe0e1e9e109f.jpg";